export const MANANA = 'MAN'
export const TARDE = 'TAR'
export const NOCHE = 'NOC'

export const __dictionary = {
  [MANANA]: {
    id: MANANA,
    nombre: 'MANANA'
  },
  [TARDE]: {
    id: TARDE,
    nombre: 'TARDE'
  },
  [NOCHE]: {
    id: NOCHE,
    nombre: 'NOCHE'
  }
}

export const __array = [__dictionary[MANANA], __dictionary[TARDE], __dictionary[NOCHE]]
